import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import LayoutWrapper from "./components/LayoutWrapper";
import Dev from "./pages/Dev";
import PrivacyPolicy from "./pages/PrivacyPolicy"
import AboutUs from "./pages/AboutUs"
import Careers from "./pages/Careers"
import Chat from "./pages/Chat"
import Tracker from "./pages/Tracker"
import Stats from "./pages/Stats"

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    // <React.StrictMode>
    <Router>
        <Routes>
            {/*<Route path="/signup" element={<LayoutWrapper component={Signup}/>}/>*/}
            {/*<Route path="/login" element={<LayoutWrapper component={Login}/>}/>*/}

            <Route path="/dev" element={<LayoutWrapper component={Dev}/>}/>
            <Route path="/privacy-policy" element={<LayoutWrapper component={PrivacyPolicy}/>}/>

            <Route path="/stats" element={<LayoutWrapper component={Stats}/>}/>
            <Route path="/chat" element={<LayoutWrapper component={Chat}/>}/>
            <Route path="/tracker" element={<LayoutWrapper component={Tracker}/>}/>

            <Route path="/about-us" element={<LayoutWrapper component={AboutUs}/>}/>
            <Route path="/careers" element={<LayoutWrapper component={Careers}/>}/>


            <Route path="/privacy-policy" element={<LayoutWrapper component={PrivacyPolicy}/>}/>

            <Route path="/" element={<LayoutWrapper component={App}/>}/>

            <Route path="/*" element={<LayoutWrapper component={App}/>}/>

        </Routes>
    </Router>
    // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
